module.exports = __webpack_public_path__ + "img/11.65912f8b.png";